// extracted by mini-css-extract-plugin
export default {"card":"BackgroundForm_card__wNdgO","content":"BackgroundForm_content__fURht"};